module.exports = __webpack_public_path__ + "static/media/Paragraph.0653361c.svg";